import { useEffect, useState } from 'react';
import { BaseSelector } from '../../../domain/shared';
import { CustomersRepository } from '../../../infrastructure/repositories/customers/customerRepository';
import Select from 'react-select';

interface Props {
    onChange: (name: string, value: number | string | undefined) => void;
    value: number | string | undefined;
    name: string;
    label: string;
}

export default function CustomerSelector({ onChange, value, name, label }: Props) {
    const [customers, setCustomers] = useState<BaseSelector[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [selectedValue, setSelectedValue] = useState<number | string | undefined>(
        value
    );

    useEffect(() => {
        setIsLoading(true);

        CustomersRepository.GetCustomersListSelector().then((res) => {
            setIsLoading(false);
            setCustomers(
                res.map((c) => ({
                    label: c.name,
                    value: c.id,
                }))
            );
        });
    }, []);

    useEffect(() => {
        setSelectedValue(value);
    }, [value]);

    const handleChange = (selectedOption: BaseSelector | null) => {
        const newValue = selectedOption?.value;
        setSelectedValue(newValue);
        onChange(name, newValue);
    };

    return (
        <div className='mb-2'>
            <label htmlFor='ubications' className='form-label form-label'>
                {label}
            </label>
            <Select
                className='basic-single'
                classNamePrefix='select'
                isLoading={isLoading}
                isSearchable
                name='color'
                options={customers}
                onChange={(c) => {
                    onChange(name, c?.value);
                }}
                value={
                    customers.find((c) => c.value === value) ?? {
                        label: 'Seleccione',
                        value: 0,
                    }
                }
            />
        </div>
    );
}
